module.exports = __webpack_public_path__ + "img/gamifinnopoly_small.cf1cc7cb.png";